import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../../../icon/icon';

type Props = {
  onClick: (e: React.MouseEvent) => void;
  disabled?: boolean;
};

const DuplicateIcon = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Icon
      disabled={props.disabled}
      fixedWidth={true}
      icon={['fal', 'copy']}
      mouseDownStyle={{ opacity: 0.5 }}
      stopPropagationOnClick={true}
      title={t('common.assetHeaderIcons.duplicate', { ns: 'skyviewAssetMenu' })}
      onClick={props.onClick}
      onHoverStyle={{ icon: ['fad', 'copy'] }}
    />
  );
};

export { DuplicateIcon };
